<template lang="">
  <div>
     <el-form ref="ruleForm" :rules="rules" :model="form" >
        <el-form-item  prop="fileList">
          <el-upload
                  ref="upload"
                  name="file"
                  action=""
                  :before-remove="handleRemove"
                  :on-change="handleChange"
                  :auto-upload="false"
                  accept="image/*"
                  :show-file-list="false"
                  :file-list="form.fileList">
                    <div class="uploadBtnContent">
                      <div class="btnContent">
                        <i class="el-icon-upload2 upload"/>
                        <i v-if="this.list && this.list.length > 1" class="el-icon-delete del" @click.stop="del"/>
                      </div>
                      <div class="uploadBtnContent">
                        <img v-if="form.fileList[0] && form.fileList[0].fileUrl!==''"
                            :src="form.fileList[0].fileUrl"
                            class="avatar"/>
                        <i v-else class="el-icon-plus add"/>
                      </div>
                    </div>
            </el-upload>
        </el-form-item>
      </el-form>
    <!-- <div v-if="form.fileList.length === 0" class="tip">{{tipMes?tipMes:''}}</div> -->
  </div>
</template>
<script>
import eventBus from '@/assets/js/eventBus'
import { Loading } from 'element-ui'
import { previewFileUpload } from '@/api/fileServer'
export default {
  props: {
    data: {
      type: Object
    },
    tipMes: {
      type: String
    },
    index: {
      type: Number || null
    },
    list: {
      type: Array || null
    },
    item: {
      type: Object || null
    }
  },
  created() {
    if (this.data) {
      eventBus.$on('validatePicList', this.validatePicList)// 验证表单
      eventBus.$on('resetFields', this.resetFields)// 重置表单
    }

    // 测试
    // let val = {
    //   "pathKey": "product/img/20240506/09c11ee9bba140ce87dbed571e109c77.png",
    //   "fileUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/product/img/20240506/09c11ee9bba140ce87dbed571e109c77.png?Expires=1715570593&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=B9bJ0w9BrZsM4ECGyXhZn%2FpamQk%3D"
    // };
    // const fileItem = {
    //   fileUrl: val.fileUrl,
    //   fileKey: val.pathKey
    // }
    // if (this.item) {
    //   console.log('this.item888:', this.item)
    //   this.item.fileName = '123'
    //   this.item.fileToken = fileItem.fileKey
    // } else {
    //   console.log('this.data88:', this.data)
    //   this.data.fileName = '123'
    //   this.data.fileToken = fileItem.fileKey
    // }
    // this.form.fileList.splice(0, 1, fileItem)
  },
  data() {
    const fileListValidate = (rule, value, callback) => {
      if (this.form.fileList.length === 0) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    }
    return {
      form: {
        fileList: this.data && this.data.fileList
          ? Object.assign([], this.data.fileList)
          : this.item && this.item.fileList
            ? Object.assign([], this.item.fileList)
            : []
      },
      rules: {
        fileList: [
          { validator: fileListValidate, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resetFields() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    validatePicList() {
      this.$refs.ruleForm && this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          this.data.validate = false;
        } 
      })
    },
    del() {
      if (this.item) {
        eventBus.$emit('addDelImg', [this.item.fileToken])
      } else {
        eventBus.$emit('addDelImg', [this.data.fileToken])
      }
      console.log('del')
      if (this.list && this.list[this.index]) {
        this.list.splice(this.index, 1)
      }
    },
    handleChange(file, fileList) {
      const size = file.size
      if (size > 1024 * 1024 * 5) {
        this.$message({
          message: '图片大小应不大于5M，请重新上传！',
          type: 'warning',
          duration: 1000
        })
        return
      }
      if (file.raw.type !== 'image/jpeg' && file.raw.type !== 'image/jpg' && file.raw.type !== 'image/png') {
        this.$message.error('上传文件只能是图片格式！')
        return false
      }
      if (this.item) {
        eventBus.$emit('addDelImg', [this.item.fileToken])
      } else {
        eventBus.$emit('addDelImg', [this.data.fileToken])
      }
      console.log('file:', file)
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('dir', 'product/img/')
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      // this.form.fileList = fileList
      const loading = Loading.service({
        lock: true,
        text: '文件上传中……',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      previewFileUpload(formData).then(res => {
        if (res.status === 200) {
          res = res.data
          const fileItem = {
            fileUrl: res.data.fileUrl,
            fileKey: res.data.pathKey
          }
          if (this.item) {
            console.log('this.item888:', this.item)
            this.item.fileName = file.name
            this.item.fileToken = res.data.pathKey
          } else {
            console.log('this.data88:', this.data)
            this.data.fileName = file.name
            this.data.fileToken = res.data.pathKey
          }
          loading.close()
          this.form.fileList.splice(0, 1, fileItem)
          this.$refs.ruleForm.clearValidate()// 清除表单校验信息
        }
      })
    },
    handleRemove() {
      this.form.fileList.splice(0)
    }
    // beforeUp (file) {
    //   if (file.type !== 'image/jpeg' || file.type !== 'image/jpg' || file.type !== 'image/png') {
    //     this.$message.error('上传文件只能是图片格式！')
    //     return false
    //   }
    //   return true
    // }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-form-item__content {
  position: relative;
}

.el-form-item__error {
  bottom: 10px;
  left: 22px;
  bottom: -6px;
}

.tip {
  color: #b2b3b7;
  line-height: 20px;
  margin-top: 20px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
}

/deep/.avatar-uploader {
  width: 100px;
  height: 100px;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.uploadBtnContent {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &:hover .btnContent {
    z-index: 9999;
    display: block;
  }

  &:hover .add {
    display: none;
  }

  .btnContent {
    z-index: -9999;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #80808040;
    display: none;
    left: 0;
    top: 0;
  }
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

// .uploadBtnContent{
//    width: 100px;
//   height: 100px;
//   position: relative;
//   &:hover .btnContent{
//      display: block;
//     }
//   &:hover .add{
//      display: none;
//     }
//   .btnContent{
//     font-size: 24px;
//     display: none;
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     background-color:rgba(158,158,158,0.2);
//     display: none;
//     left: 0;
//     top: 0;
//     .del{
//       margin-left: 10px;
//     }
//   }
// }</style>
